var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatascience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "data_science",
    "data-name": "data science",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.583,
    height: 70.775,
    viewBox: "0 0 73.583 70.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483",
    transform: "translate(3.919 1.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2475",
    "data-name": "Group 2475",
    transform: "translate(6.035 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M149.871,87.382c-2.014-.5-4.167-.942-6.431-1.328a44.528,44.528,0,0,0,0-20.907c2.263-.386,4.417-.829,6.431-1.328a.817.817,0,0,0-.389-1.587c-2.022.5-4.187.945-6.466,1.33a35.75,35.75,0,0,0-5.478-11.31q-.241-.327-.488-.643c1.054-.2,2.068-.414,3.031-.649a.817.817,0,0,0-.384-1.588c-1.208.295-2.5.56-3.847.794-4.428-4.994-9.968-7.714-15.832-7.714s-11.405,2.72-15.833,7.714c-1.352-.234-2.639-.5-3.847-.794a.817.817,0,0,0-.384,1.588c.964.235,1.977.451,3.031.649q-.247.317-.489.643a35.749,35.749,0,0,0-5.478,11.31c-2.279-.385-4.444-.83-6.466-1.33a.817.817,0,0,0-.389,1.587c2.014.5,4.168.942,6.431,1.328a44.528,44.528,0,0,0,0,20.907c-2.263.386-4.417.829-6.431,1.328a.817.817,0,0,0,.389,1.587c2.022-.5,4.187-.945,6.466-1.33a35.749,35.749,0,0,0,5.478,11.31q.241.327.489.643c-1.054.2-2.068.414-3.031.649a.817.817,0,0,0,.384,1.588c1.208-.295,2.5-.56,3.847-.794,4.428,4.994,9.968,7.714,15.833,7.714s11.405-2.72,15.832-7.714c1.352.234,2.639.5,3.847.794a.806.806,0,0,0,.193.023.817.817,0,0,0,.191-1.611c-.964-.235-1.977-.451-3.031-.649q.247-.317.488-.643a35.75,35.75,0,0,0,5.478-11.31c2.279.385,4.444.83,6.466,1.33a.8.8,0,0,0,.2.024.818.818,0,0,0,.194-1.611ZM143.058,75.6a41.98,41.98,0,0,1-1.237,10.19c-3.682-.571-7.626-1-11.721-1.259.243-2.87.368-5.869.368-8.931s-.126-6.061-.368-8.931c4.094-.264,8.039-.688,11.721-1.259a41.981,41.981,0,0,1,1.237,10.19ZM126.027,98.315c-1.963-.109-3.975-.165-6.01-.165s-4.046.056-6.009.165l-.027-.088a67.4,67.4,0,0,1-2.271-12.163c2.72-.145,5.5-.219,8.307-.219s5.587.075,8.307.219a67.4,67.4,0,0,1-2.271,12.163l-.027.088Zm-6.01,8.8c-1.9,0-3.9-2.655-5.488-7.191,1.8-.092,3.632-.139,5.488-.139s3.692.047,5.488.139C123.916,104.459,121.912,107.114,120.017,107.114Zm0-22.9c-2.857,0-5.688.077-8.459.226-.241-2.836-.366-5.8-.366-8.836s.125-6,.366-8.836c2.771.149,5.6.226,8.459.226s5.688-.077,8.459-.226c.241,2.836.366,5.8.366,8.836s-.125,6-.366,8.836C125.706,84.288,122.875,84.211,120.017,84.211Zm-6.01-31.325c1.963.109,3.975.165,6.01.165s4.046-.056,6.01-.165l.027.088a67.4,67.4,0,0,1,2.271,12.163c-2.721.145-5.5.219-8.307.219s-5.586-.075-8.307-.219a67.4,67.4,0,0,1,2.271-12.163l.027-.088Zm6.01-8.8c1.9,0,3.9,2.655,5.488,7.191-1.8.092-3.632.139-5.488.139s-3.692-.047-5.488-.139C116.118,46.742,118.122,44.087,120.017,44.087Zm21.371,19.738c-3.6.552-7.444.961-11.439,1.217a69.841,69.841,0,0,0-2.257-12.262c2.634-.189,5.162-.475,7.517-.851a33.412,33.412,0,0,1,6.179,11.9Zm-7.481-13.35c-2.123.308-4.378.544-6.715.7a20.172,20.172,0,0,0-3.387-6.662A20.441,20.441,0,0,1,133.908,50.475Zm-17.678-5.959a20.173,20.173,0,0,0-3.387,6.662c-2.338-.159-4.592-.395-6.716-.7a20.439,20.439,0,0,1,10.1-5.959Zm-11.4,7.414c2.355.376,4.884.662,7.517.851a69.838,69.838,0,0,0-2.257,12.262c-4-.256-7.844-.666-11.439-1.217A33.41,33.41,0,0,1,104.825,51.929ZM96.976,75.6a41.98,41.98,0,0,1,1.237-10.19c3.682.571,7.626,1,11.721,1.259-.243,2.87-.368,5.869-.368,8.931s.126,6.061.368,8.931c-4.095.264-8.039.688-11.721,1.259A41.98,41.98,0,0,1,96.976,75.6Zm1.67,11.776c3.6-.552,7.444-.961,11.439-1.217a69.838,69.838,0,0,0,2.257,12.262c-2.634.189-5.162.475-7.517.851A33.407,33.407,0,0,1,98.646,87.376Zm7.48,13.35c2.123-.308,4.378-.544,6.716-.7a20.169,20.169,0,0,0,3.387,6.662,20.444,20.444,0,0,1-10.1-5.959Zm17.678,5.959a20.175,20.175,0,0,0,3.387-6.662c2.338.159,4.593.395,6.715.7a20.441,20.441,0,0,1-10.1,5.959Zm11.4-7.414c-2.355-.376-4.884-.662-7.517-.851a69.841,69.841,0,0,0,2.257-12.262c4,.256,7.844.666,11.439,1.217A33.407,33.407,0,0,1,135.209,99.272Z",
    transform: "translate(-89.544 -42.453)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2474",
    "data-name": "Group 2474",
    transform: "translate(9.905 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M197.587,142.833l-3.92-.623a15.807,15.807,0,0,0-1.134-2.733l2.333-3.214a1.729,1.729,0,0,0-.177-2.238l-3.338-3.338a1.729,1.729,0,0,0-2.238-.177l-3.214,2.333a15.775,15.775,0,0,0-2.733-1.134l-.623-3.92a1.729,1.729,0,0,0-1.707-1.458h-4.721a1.729,1.729,0,0,0-1.707,1.458l-.623,3.92a15.79,15.79,0,0,0-2.733,1.134l-3.214-2.332a1.729,1.729,0,0,0-2.238.177l-3.338,3.338a1.729,1.729,0,0,0-.177,2.238l2.333,3.214a15.8,15.8,0,0,0-1.134,2.733l-3.92.623a1.729,1.729,0,0,0-1.458,1.707v4.721a1.729,1.729,0,0,0,1.458,1.707l3.92.623a15.808,15.808,0,0,0,1.134,2.733l-2.333,3.214a1.729,1.729,0,0,0,.177,2.238l3.338,3.338a1.729,1.729,0,0,0,2.238.177l3.214-2.333a15.78,15.78,0,0,0,2.733,1.134l.623,3.92a1.729,1.729,0,0,0,1.707,1.458h4.721a1.729,1.729,0,0,0,1.708-1.458l.623-3.92a15.807,15.807,0,0,0,2.733-1.134l3.214,2.333a1.729,1.729,0,0,0,2.238-.177l3.338-3.338a1.729,1.729,0,0,0,.177-2.238l-2.332-3.214a15.791,15.791,0,0,0,1.134-2.733l3.92-.623a1.729,1.729,0,0,0,1.458-1.707V144.54a1.729,1.729,0,0,0-1.458-1.707Zm-10.8,4.069a8.309,8.309,0,1,1-8.31-8.31A8.309,8.309,0,0,1,186.786,146.9Z",
    transform: "translate(-157.908 -126.332)",
    fill: "#b3b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M197.058,182.515l-.692-4.358q.56.052,1.133.052t1.135-.052l-.692,4.358Zm8.286-7.143a12.406,12.406,0,0,0,1.605-1.6l2.6,3.576-.624.624Zm-19.888,1.971,2.6-3.576a12.414,12.414,0,0,0,1.6,1.6l-3.576,2.6Zm-4.547-10.978v-.883l4.358-.692q-.052.56-.052,1.135t.052,1.133Zm28.826.692q.052-.56.052-1.133t-.052-1.135l4.358.692v.883Zm-2.785-8.978a12.407,12.407,0,0,0-1.605-1.605l3.576-2.6.624.624ZM185.455,154.5l.625-.625,3.576,2.6a12.4,12.4,0,0,0-1.6,1.605Zm13.179-.814q-.56-.052-1.135-.052t-1.133.052l.692-4.358h.883Z",
    transform: "translate(-176.931 -145.355)",
    fill: "#d9d9ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2481",
    "data-name": "Group 2481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2480",
    "data-name": "Group 2480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2476",
    "data-name": "Group 2476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M88.02,317.513H61.368a1.729,1.729,0,0,1-1.729-1.729V289.132a1.729,1.729,0,0,1,1.729-1.729H88.02a1.729,1.729,0,0,1,1.729,1.729v26.652A1.729,1.729,0,0,1,88.02,317.513Z",
    transform: "translate(-58.775 -248.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M111.586,49.54a33.244,33.244,0,0,0-53.77,26.141c0,.813.033,1.665.1,2.532a.819.819,0,0,0,1.634-.123c-.062-.827-.094-1.637-.094-2.409a31.608,31.608,0,1,1,31.6,31.594,31.873,31.873,0,0,1-6.241-.618V84.217A2.461,2.461,0,0,0,82.36,81.76H57.1a2.461,2.461,0,0,0-2.458,2.457v25.254a2.461,2.461,0,0,0,2.458,2.457H72.139a.819.819,0,1,0,0-1.638H57.1a.82.82,0,0,1-.819-.819V84.217A.82.82,0,0,1,57.1,83.4H82.36a.82.82,0,0,1,.819.819v25.254a.82.82,0,0,1-.819.819h-5.5a.819.819,0,1,0,0,1.638h5.5a2.461,2.461,0,0,0,2.458-2.457v-1.145a33.535,33.535,0,0,0,6.241.587A33.23,33.23,0,0,0,111.586,49.54Z",
    transform: "translate(-54.639 -42.45)",
    fill: "#3335cf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2477",
    "data-name": "Group 2477",
    transform: "translate(4.382 47.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M79.986,340.026V357.25H99.517a.234.234,0,0,0,.155-.41l-19.3-16.99A.234.234,0,0,0,79.986,340.026Z",
    transform: "translate(-79.985 -339.791)",
    fill: "#f2d3cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M103.056,364.657v12.73a.234.234,0,0,1-.233.235H79.982l6.034-7.334a.235.235,0,0,1,.363,0l3.033,3.686,6.534-7.943a.235.235,0,0,1,.363,0l2.54,3.086,3.793-4.611a.234.234,0,0,1,.415.15Z",
    transform: "translate(-79.982 -360.162)",
    fill: "#ff7b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2479",
    "data-name": "Group 2479",
    transform: "translate(15.848 48.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2478",
    "data-name": "Group 2478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M153.106,341.52h5.741a.864.864,0,1,0,0-1.729h-5.741a.864.864,0,1,0,0,1.729Z",
    transform: "translate(-152.242 -339.791)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 0.864,
    cy: 0.864,
    r: 0.864,
    transform: "translate(8.853)",
    fill: "#c5c5ff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M98.924,350.893H76.715v-3.317h.54a.864.864,0,0,0,0-1.729h-.54v-2.312h.54a.864.864,0,1,0,0-1.729h-.54v-2.312h.54a.865.865,0,0,0,0-1.729h-.54v-3.75a.864.864,0,0,0-1.729,0v17.742a.864.864,0,0,0,.864.864H98.924a.864.864,0,1,0,0-1.729Z",
    transform: "translate(-71.468 -286.736)",
    fill: "#8383ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484",
    transform: "translate(0 26.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M34.8,245.315a.864.864,0,0,1-.864-.864,1.1,1.1,0,0,0-1.095-1.095.864.864,0,0,1,0-1.729,1.1,1.1,0,0,0,1.095-1.095.864.864,0,0,1,1.729,0,1.1,1.1,0,0,0,1.095,1.095.864.864,0,0,1,0,1.729,1.1,1.1,0,0,0-1.095,1.095A.864.864,0,0,1,34.8,245.315Z",
    transform: "translate(-31.973 -239.667)",
    fill: "#ffab66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2485",
    "data-name": "Group 2485",
    transform: "translate(63.212 61.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M422.563,421.127a.864.864,0,0,1-.865-.864,1.1,1.1,0,0,0-1.095-1.1.864.864,0,0,1,0-1.729,1.1,1.1,0,0,0,1.095-1.095.864.864,0,0,1,1.729,0,1.1,1.1,0,0,0,1.095,1.095.864.864,0,1,1,0,1.729,1.1,1.1,0,0,0-1.095,1.1A.865.865,0,0,1,422.563,421.127Z",
    transform: "translate(-419.739 -415.479)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2486",
    "data-name": "Group 2486",
    transform: "translate(0.403 14.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M41.171,185.015a.862.862,0,0,1-.611-.253l-.945-.945-.945.945a.865.865,0,0,1-1.223-1.223L39,181.984a.865.865,0,0,1,1.222,0l1.556,1.556a.865.865,0,0,1-.611,1.476Z",
    transform: "translate(-37.194 -181.731)",
    fill: "#8383ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2487",
    "data-name": "Group 2487",
    transform: "translate(65.344 5.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M436.049,69.243a.862.862,0,0,1-.611-.253l-.945-.945-.945.945a.864.864,0,1,1-1.223-1.222l1.556-1.556a.864.864,0,0,1,1.223,0l1.556,1.556a.864.864,0,0,1-.611,1.476Z",
    transform: "translate(-432.072 -65.958)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2488",
    "data-name": "Group 2488",
    transform: "translate(58.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M394.82,38.238a.862.862,0,0,1-.611-.253l-.945-.945-.945.945a.864.864,0,1,1-1.223-1.222l1.556-1.556a.864.864,0,0,1,1.223,0l1.556,1.556a.864.864,0,0,1-.611,1.476Z",
    transform: "translate(-390.843 -34.953)",
    fill: "#ffab66"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatascience);
export default __webpack_public_path__ + "static/media/data science.59343dcc6427200344bc90ab2eb7f23c.svg";
export { ForwardRef as ReactComponent };